import { List, Create, Show, NewOld, Print, Edit, MyPending, Status } from "../Components/index.js";

export default [
    {
        path: "/move-order-list",
        component: List,
        name: "move-order-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/move-order-approval-pending",
        component: MyPending,
        name: "move-order-pending",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/move-order/create",
        component: Create,
        name: "move-order-new",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/move-order/old",
        component: NewOld,
        name: "move-order-old",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/move-order/:id/show",
        component: Show,
        name: "move-order.show",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/move-order/:id/edit",
        component: Edit,
        name: "move-order.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/move-order/:id/print",
        component: Print,
        name: "move-order.print",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/move-order/leave-status",
        component: Status,
        name: "report.move-order.status",
        meta: {
            requiresAuth: true,
        },
    },
];
